import { NotFoundContent } from './legal-pages';

export function NotFoundPage() {
  return <NotFoundContent />;
}
